import React from 'react'
import PropTypes from 'prop-types'

import Link from 'components/link'
import { TikTokIcon } from 'components/icons'
import * as blUrls from 'lib/urls'
import { socialLinks } from './constants'
import * as css from './SocialLinks.scss'

const SocialLinks = ({ className }) => (
  <div className={className}>
    <div className="h7 text-uppercase mvl mbs text-bold">Connect with us</div>
    <ul className="list-inline">
      <li key="0" className="prn mbs mhs" style={{ paddingLeft: 4 }}>
        <Link
          url={blUrls.tiktokUrl}
          className={css.socialLink}
          newWindow
          aria-label="TikTok"
        >
          <TikTokIcon className="fa-tiktok" width="20" height="20" />
        </Link>
      </li>
      {socialLinks.map((link) => (
        <li key={link.name} className="prn mbs mhs" style={{ paddingLeft: 4 }}>
          <Link
            url={link.href}
            className={css.socialLink}
            newWindow
            aria-label={link.name}
          >
            <i className={`fa ${link.icon}`} aria-hidden="true" />
          </Link>
        </li>
      ))}
    </ul>
  </div>
)

SocialLinks.propTypes = {
  className: PropTypes.string,
}

SocialLinks.defaultProps = {
  className: '',
}

export default SocialLinks
